<section class="main-grid">
  <div class="info-box">
    <h3>Gdje možete donirati krv</h3>
    <p>Radno vrijeme u svim jedinicama: 07:15 - 14:45</p>
    <table>
      <thead>
        <tr><th>Ustanova</th><th>Telefon</th></tr>
      </thead>
      <tbody>
        <tr><td>Podgorica</td><td>020 240 715</td></tr>
        <tr><td>Bar</td><td>030/342-212</td></tr>
        <tr><td>Berane</td><td>068/043-111</td></tr>
        <tr><td>Bijelo Polje</td><td>050/486-102</td></tr>
        <tr><td>Cetinje</td><td>041/232-740</td></tr>
        <tr><td>Kotor</td><td>068/047-111</td></tr>
        <tr><td>Nikšić</td><td>068/042-111</td></tr>
        <tr><td>Pljevlja</td><td>068/048-111</td></tr>
        <tr><td>Risan</td><td>032/326-163</td></tr>
      </tbody>
    </table>
  </div>